export interface BrowserLoggerConfig {
  level: 'trace' | 'debug' | 'info' | 'warn' | 'error';
  enableConsole: boolean;
  enableRemote: boolean;
  remoteUrl: string;
  enableRedaction: boolean;
}

// Project IDs for different environments
const PROJECT_IDS = {
  development: 'aiprep-465906',
  production: 'aiprep-prod',
} as const;

// Environment detection helpers
const isProductionEnvironment = (hostname: string): boolean => {
  return hostname === 'aiprep.io' ||
         hostname === 'www.aiprep.io' ||
         hostname === 'app.aiprep.io';
};

const getRemoteLogUrl = (hostname: string): string => {
  if (isProductionEnvironment(hostname)) {
    return `https://us-central1-${PROJECT_IDS.production}.cloudfunctions.net/clientLogs`;
  }
  return `https://us-central1-${PROJECT_IDS.development}.cloudfunctions.net/clientLogs`;
};

export const getLoggerConfig = (): BrowserLoggerConfig => {
  const hostname = window.location.hostname;
  const isDevelopment = hostname === 'localhost' || hostname === '127.0.0.1';
  const isStaging = hostname.includes('staging') || hostname.includes('dev') ||
                   hostname.includes(PROJECT_IDS.development) || hostname === `${PROJECT_IDS.development}.firebaseapp.com`;

  if (isDevelopment) {
    return {
      level: 'debug',
      enableConsole: true,
      enableRemote: false, // Don't send to cloud in local dev
      remoteUrl: '/api/logs',
      enableRedaction: false
    };
  }

  if (isStaging) {
    return {
      level: 'info',
      enableConsole: true,
      enableRemote: true,
      remoteUrl: getRemoteLogUrl(hostname),
      enableRedaction: true
    };
  }

  // Production
  return {
    level: 'warn',
    enableConsole: false,
    enableRemote: true,
    remoteUrl: getRemoteLogUrl(hostname),
    enableRedaction: true
  };
};
